import type { ValidationResult, ValidationRule } from '../types';

export const isRequiredField =
  (errorMessage: string): ValidationRule =>
  (inputToValidate: string): ValidationResult => {
    const isValid = inputToValidate?.trim() !== '';
    return { error: !isValid, errorMessage };
  };
